import {isEmpty, get} from "lodash";
import {useSelector} from "react-redux";

export function useSetTranslation() {
  const isDefault = useSelector(state => get(state, "auth.user.newPrimaryLanguage") === state.language.defaultLanguageCode);

  const st = (defaultText, localeText) => isDefault ? defaultText : !isEmpty(localeText) ? localeText : defaultText;
  return {st};
}
